






import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'search-bar',
})
export default class SearchBar extends Vue {
  public searchQuery: string|null = null;
}
